module.exports = __webpack_public_path__ + "static/media/chart-icon.2b295c96.svg";